import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MutateFn } from '@diritto/common/base/mutateFunction';
import { ProfileSettingTypeExtraInfo } from '@diritto/common/account/constants/profile-setting.constant';
import { ProfileApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';
import { accountsQueryKey } from 'queries/account/queryKey';

export const useUpdateProfileSettingMutation = (callback?: MutateFn) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (extraDataInfo: ProfileSettingTypeExtraInfo[keyof ProfileSettingTypeExtraInfo]) =>
      ProfileApi.updateProfileSetting({
        type: extraDataInfo.type,
        extraDataInfo,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: relayQueryKey.relayContent });
      queryClient.invalidateQueries({ queryKey: accountsQueryKey.user });
    },
    ...callback,
  });
};
